import { fansupportPublic } from "../index";

export const getUsername = async ({ Value }) => {
    return fansupportPublic.get('/identity/check-username', {params: {
        Value,
    }})
}